import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useLms } from '../../context/LmsContext';
import CoursePreview from '../../components/CoursePreview';
import { Card, ProgressBar, StatusBadge } from '../../components/ui';
import {
  derivedAssignmentStatus,
  getAssignmentProgress,
  getCourse,
  getNextIncompleteItem
} from '../../utils/lmsSelectors';

export default function LearnerCourse() {
  const { assignmentId } = useParams();
  const { data, currentUser } = useLms();
  const assignment = data.assignments.find((item) => item.id === assignmentId && item.assignedToUserId === currentUser.id);
  if (!assignment) return <Card>Assignment not found or access removed.</Card>;
  const course = getCourse(data, assignment.courseId);
  const progress = getAssignmentProgress(data, assignment);
  const nextItem = getNextIncompleteItem(data, assignment);
  const certificate = data.certificates.find((cert) => cert.assignmentId === assignment.id && cert.status === 'active');

  return (
    <>
      <div className="grid four">
        <Card><span className="muted">Status</span><h2><StatusBadge status={derivedAssignmentStatus(data, assignment)} /></h2></Card>
        <Card><span className="muted">Progress</span><ProgressBar value={progress.percent} /></Card>
        <Card><span className="muted">Due date</span><h2>{assignment.dueDate || 'No due date'}</h2></Card>
        <Card>
          <span className="muted">Certificate</span>
          <h2>{certificate ? 'Available' : 'Not available yet'}</h2>
          {certificate && <Link className="button button-secondary full" to="/learner/certificates">View certificate</Link>}
        </Card>
      </div>
      <Card>
        <div className="button-row">
          {nextItem?.type === 'lesson' && <Link className="button button-primary" to={`/learner/lesson/${assignment.id}:${nextItem.id}`}>Continue next lesson</Link>}
          {nextItem?.type === 'quiz' && <Link className="button button-primary" to={`/learner/quiz/${assignment.id}:${nextItem.id}`}>Take next quiz</Link>}
          {nextItem?.type === 'exercise' && <Link className="button button-primary" to={`/learner/exercise/${assignment.id}:${nextItem.id}`}>Open next exercise</Link>}
          {!nextItem && certificate && <Link className="button button-secondary" to="/learner/certificates">View certificate</Link>}
        </div>
      </Card>
      <Card>
        <CoursePreview data={data} course={course} assignment={assignment} mode="learner" />
      </Card>
    </>
  );
}
